import React, { useCallback, useState } from 'react';

import './_stream-page.scss';

import { Modal, Tabs, Tab, TabPanels, TabPanel, TabList } from '@carbon/react';
import { StreamsModalIndex } from './StreamsIndex';
import { ElementsModalIndex } from '../ElementsPage/ElementsPage';

const SelectElementModal = ({streamId, hideModal, onSelectElements = () => {} }) => {

  // ElementsModalIndex emits the same tile shape the gallery uses, including
  // synthetic variant-group tiles. The receiver in StreamListItem decides
  // per tile whether to wire up a plain element or a variant-backed item.
  const [selections, setSelections] = useState([]);
  const [streams, setStreams] = useState([]);

  const onCloseRequest = () => {
    hideModal();
  };

  const onSubmitRequest = () => {
    onSelectElements({
      selections: selections,
      streams: streams,
    });
    hideModal();
  };

  const onItemSelected = (items) => {
    setSelections(items);
  };

  const onStreamItemSelected = useCallback((items) => {
    setStreams(items);
  }, [setStreams]);

  return (
    <Modal
      open={true}
      danger={false}
      size="lg"
      primaryButtonText={'Auswählen'}
      secondaryButtonText={'Abrechen'}
      modalHeading=""
      onRequestClose={onCloseRequest}
      onRequestSubmit={onSubmitRequest}
      className="prevent-scroll-content">
      <Tabs type="container">
        <TabList
          aria-label="Auswahl-Reiter"
          contained
        >
          <Tab id="tab_elements">
            Elemente
          </Tab>
          <Tab id="tab_streams">
            Streams
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel id="tab_elements_panel" className="tab-content">
            <ElementsModalIndex
              onSelectItem={onItemSelected}
            />
          </TabPanel>
          <TabPanel id="tab_streams_panel" className="tab-content">
            <StreamsModalIndex onSelectionChange={onStreamItemSelected} forStreamID={streamId}/>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Modal>
  );
}

export default SelectElementModal;
